import { Link } from "react-router-dom";
import images from "../constants/images";
import Header from "../components/header";
import Clickable from "../components/clickable.";
import Page from "../components/page";
import { useEffect, useState } from "react";
import api from "../functions/api";

const Employees = () => {
    const [employee, setEmployee] = useState();

    const getEmployees = async () => {
        try {
            const data = await api.get("/employees");
            setEmployee(data);
        } catch (err) {
            console.log("🚀 ~ getEmployees ~ err:", err);
        }
    };

    useEffect(() => {
        getEmployees();
    }, []);

    return (
        <Page title="Employees">
            <div className="employees">
                {employee?.map((item, index) => (
                    <Link
                        to={`/employee-details/${item?._id}`}
                        className="style-5"
                        key={index}
                    >
                        <div className="num">{item?._id}</div>

                        <div className="style-7">
                            <div className="style-8">{item?.name}</div>
                            <div className="style-11">{item?.salary}</div>

                            {/* 
                            <Clickable>
                                <img src={images.delete} className="btn" />
                            </Clickable> */}
                        </div>
                    </Link>
                ))}

                <Clickable to="/employee-add" className="style-15">
                    <img src={images.add} className="style-17" />
                </Clickable>
            </div>
        </Page>
    );
};

export default Employees;
